<template lang="pug">
div
  y-dialog(v-if="showDialog" v-model="showDialog" max-width="1000" persistent fluid scrollable content-class="round-2xl")
    v-card(height="90vh")
      v-card-title.pa-0
        div(style="width: 100%;")
          div.pa-4
            v-row(no-gutters)
              v-col(cols="10" offset="1")
                .text-xl.font-bold.text-center Review offers
              v-col(cols="1" align="right")
                v-btn(icon @click="closeDialog" small color="primary")
                  v-icon mdi-close
          v-divider
          div.pt-6.px-6
            div.main-container
              v-tabs(v-model="tabs" color="neutral700" :height="50" fixed-tabs slider-size="2")
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 0 ? 'opacity: 1' : ''" disabled) 1. Applies to
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 1 ? 'opacity: 1' : ''" disabled) 2. Redemption
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 2 ? 'opacity: 1' : ''" disabled) 3. Offer Rewards
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 3 ? 'opacity: 1' : ''" disabled) 4. Eligibility
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 4 ? 'opacity: 1' : ''" disabled) 5. WhatsApp
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 5 ? 'opacity: 1' : ''" disabled) 6. SMS
                v-tab.text-sm.font-semibold.neutral700--text.text-capitalize.px-0(:style="tabs === 6 ? 'opacity: 1' : ''" disabled) 7. Email
              div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
      v-card-text.pa-6
        v-form(ref="form")
          v-tabs-items(v-model="tabs" touchless style="overflow: unset")
            v-tab-item
              div.px-6
                div.text-md.font-semibold.neutral700--text Which inventory & services this offer will be applied to?
                v-radio-group.mt-0(v-model="offer.upon_any_purchase" @change="sanitizeUnusedObject(null,['purchase_products'])")
                  v-radio.mt-3(:value="true" color="neutral700")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text All inventory & services
                  v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text Specific inventory & services
                template(v-if="offer.hasOwnProperty('upon_any_purchase') && !offer.upon_any_purchase")
                  inventory-services-selection(v-model="offer.purchase_products")
            v-tab-item
              div.px-6
                div.text-md.font-semibold.neutral700--text How to redeem
                .text-sm.neutral700--text(style="margin-top: 2px;") Set on how your customer will redeem this offer
                v-radio-group.mt-0(v-model="offer.redeem_method" @change="sanitizeUnusedObject(['coupon_code'])")
                  v-radio.mt-3(value="show_message" color="neutral700")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text Show message at counter
                  v-radio.mt-3(value="general_code" color="neutral700" style="align-items: unset;")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text Create general coupon code
                  template(v-if="offer.redeem_method && offer.redeem_method === 'general_code'")
                    v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.coupon_code" placeholder="Enter your code here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                  v-radio.mt-3(value="unique_code" color="neutral700")
                    template(v-slot:label)
                      div.text-md.font-medium.neutral700--text Generate unique coupon code for every customer
                v-divider
                div.text-md.font-semibold.neutral700--text.mt-5 Active date and time
                .text-sm.neutral700--text(style="margin-top: 2px;") Set active period for this offer
                v-row
                  v-col(cols="7")
                    v-card.round-xl.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                      div.pa-4
                        v-row(dense)
                          v-col(cols="2")
                            div.text-md.font-medium.neutral700--text.mt-3 Starts
                          v-col.grow
                            date-picker-field(v-model="startDate")
                          v-col.grow
                            v-text-field.text-sm.round-xl(v-model="startTime" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                        v-row(v-if="setEndAt" dense)
                          v-col(cols="2")
                            div.text-md.font-medium.neutral700--text.mt-3 Ends
                          v-col.grow
                            date-picker-field(v-model="endDate" required)
                          v-col.grow
                            v-text-field.text-sm.round-xl(v-model="endTime" background-color="neutral100" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                        yc-checkbox.mt-3(v-model="setEndAt")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text.ml-3 Set end date and time
                      v-divider.neutral300
                      div.pa-4
                        div.d-flex.align-center
                          div.text-md.font-medium.neutral700--text All-day
                          v-spacer
                          div
                            y-switch.mb-n2(v-model="offer.active_all_day" @change="sanitizeUnusedObject(['active_from', 'active_until'])")
                        v-row.mt-3(v-if="!offer.active_all_day" dense)
                          v-col.shrink
                            div.text-sm.neutral700--text.mt-3 From
                          v-col.grow
                            v-text-field.text-sm.round-xl(v-model="offer.active_from" background-color="neutral100" outlined dense height="48" type="time" hide-details="auto")
                          v-col.shrink
                            div.text-sm.neutral700--text.mt-3 until
                          v-col.grow
                            v-text-field.text-sm.round-xl(v-model="offer.active_until" background-color="neutral100" outlined dense height="48" type="time" hide-details="auto")
            v-tab-item
              div.px-6
                div.text-md.font-semibold.neutral700--text Select how you want to setup this offer’s rewards
                v-radio-group.mt-0(v-model="offer.reward_type" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['discount_percentage', 'discount_amount', 'free_item_type', 'free_item_name'], ['free_products'])")
                  v-row(no-gutters)
                    v-col(cols="6")
                      v-radio.mt-3(value="discount_percentage" color="neutral700")
                        template(v-slot:label)
                          div
                            div.text-md.font-medium.neutral700--text Percentage discount (%)
                            div.text-sm.font-normal.neutral700--text Make a discount based on percentage of the full price
                      template(v-if="offer.reward_type && offer.reward_type === 'discount_percentage'")
                        v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_percentage" placeholder="0.0" outlined dense height="48" :rules="rules.not_empty" suffix="%" type="number" hide-details="auto")
                  v-row(no-gutters)
                    v-col(cols="6")
                      v-radio.mt-3(value="discount_amount" color="neutral700")
                        template(v-slot:label)
                          div
                            div.text-md.font-medium.neutral700--text Fixed amount discount (RM)
                            div.text-sm.font-normal.neutral700--text Make a discount based on a fixed amount
                      template(v-if="offer.reward_type && offer.reward_type === 'discount_amount'")
                        v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_amount" placeholder="0.00" outlined dense height="48" :rules="rules.not_empty" :prefix="$currency.symbol" type="number" hide-details="auto")
                  v-row(no-gutters)
                    v-col(cols="6")
                      v-radio.mt-3(value="free_item" color="neutral700")
                        template(v-slot:label)
                          div
                            div.text-md.font-medium.neutral700--text Free
                            div.text-sm.font-normal.neutral700--text Give free inventory/services/visit/other item
                  v-row(no-gutters)
                    v-col(cols="10")
                      template(v-if="offer.reward_type && offer.reward_type === 'free_item'")
                        div.ml-8
                          v-row
                            v-col(cols="6")
                              y-select.mt-2(v-model="offer.free_item_type" placeholder="Select reward" attach :items="[{ text: 'Applied inventory and services', value: 'product' }, { text: 'Visit', value: 'visit' }, { text: 'Other item', value: 'other' }]" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                            v-col(v-if="offer.free_item_type && offer.free_item_type === 'other'")
                              v-text-field.text-sm.mt-2.round-xl(v-model="offer.free_item_name" placeholder="Enter item name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                  div.ml-8(v-if="offer.reward_type && offer.reward_type === 'free_item' && offer.free_item_type && offer.free_item_type === 'product'")
                    inventory-services-selection(v-model="offer.free_products")
            v-tab-item
              div.px-6
                div.text-md.font-semibold.neutral700--text Audience eligibility
                .text-sm.neutral700--text(style="margin-top: 2px;") Choose which customer you would like to direct this offers to
                yc-checkbox.mt-5(v-model="offer.to_all_customers" :disabled="disableAudienceEligibilityEveryone")
                  template(v-slot:label)
                    div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityEveryone ? 'neutral400--text' : 'neutral700--text'") Everyone
                yc-checkbox.mt-5(v-model="offer.to_all_loyalty_members" :disabled="disableAudienceEligibilityOther")
                  template(v-slot:label)
                    div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") Loyalty members
                yc-checkbox.mt-5(v-model="audienceGroups" :disabled="disableAudienceEligibilityOther")
                  template(v-slot:label)
                    div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") By segment
                div.ml-8(v-if="audienceGroups")
                  segment-selection(v-model="offer.groups" :parent-offer="offer")
                yc-checkbox.mt-5(v-model="filterCustomers" :disabled="disableAudienceEligibilityOther")
                  template(v-slot:label)
                    div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") Filter and select customers
                div.ml-8(v-if="filterCustomers")
                  customer-selection(v-model="offer.customers" :offer="offer")
            v-tab-item
              div.d-flex.justify-center.mt-16(v-if="isFetching")
                v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
              div(v-else)
                whatsapp-opportunity-offer-deliverance(ref="whatsapp" :blast-data="whatsappDeliverance" :offer="offer" @updated="updateDeliverance")
            v-tab-item
              div.d-flex.justify-center.mt-16(v-if="isFetching")
                v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
              div(v-else)
                sms-opportunity-offer-deliverance(ref="sms" :blast-data="smsDeliverance" :offer="offer" @updated="updateDeliverance")
            v-tab-item
              div.d-flex.justify-center.mt-16(v-if="isFetching")
                v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
              div(v-else)
                email-opportunity-offer-deliverance(ref="email" :blast-data="emailDeliverance" :offer="offer" @updated="updateDeliverance")

      v-divider
      v-card-actions.py-4.px-6
        y-button(v-if="tabs" label="Back" underline color="neutral700" size="md" button-class="px-0" @click="tabs--")
        y-button(v-else :label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
        v-spacer
        y-button(v-if="tabs === 6" label="Confirm" size="md" dark :loading="isLoading" @click="saveData(tabs)")
        y-button(v-else label="Next" size="md" dark :loading="isLoading" @click="saveData(tabs)")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import SegmentSelection from '@/components/clinic/marketing/SegmentSelection.vue'
import CustomerSelection from '@/components/clinic/marketing/CustomerSelection.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import SmsOpportunityOfferDeliverance from '@/components/clinic/marketing/SmsOpportunityOfferDeliverance.vue'
import WhatsappOpportunityOfferDeliverance from '@/components/clinic/marketing/WhatsappOpportunityOfferDeliverance.vue'
import EmailOpportunityOfferDeliverance from '@/components/clinic/marketing/EmailOpportunityOfferDeliverance.vue'

export default {
  components: { InventoryServicesSelection, SegmentSelection, CustomerSelection, DatePickerField, SmsOpportunityOfferDeliverance, WhatsappOpportunityOfferDeliverance, EmailOpportunityOfferDeliverance },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    opportunity: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isLoading: false,
      isFetching: false,
      audienceGroups: false,
      filterCustomers: false,setEndAt: false,
      smsDeliverance: null,
      whatsappDeliverance: null,
      emailDeliverance: null,
      startDate: null,
      startTime: '00:00',
      endDate: null,
      endTime: '00:00',
      tabs: 0,
      offer: {
        purchase_products: [],
        free_products: [],
        customers: [],
        groups: []
      },
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    disableAudienceEligibilityEveryone () {
      if (this.offer.to_all_loyalty_members) {
        return true
      }
      if (this.audienceGroups) {
        return true
      }
      if (this.filterCustomers) {
        return true
      }
      return false
    },
    disableAudienceEligibilityOther () {
      if (this.offer.to_all_customers) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchBlastData () {
      this.isFetching = true
      this.$axios.get(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`)
        .then(resp => {
          let blasts = resp.data.results
          if (blasts.find(f => f.method === 'sms')) {
            this.smsDeliverance = blasts.find(f => f.method === 'sms')
          }
          if (blasts.find(f => f.method === 'whatsapp')) {
            this.whatsappDeliverance = blasts.find(f => f.method === 'whatsapp')
          }
          if (blasts.find(f => f.method === 'email')) {
            this.emailDeliverance = blasts.find(f => f.method === 'email')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchSettings () {
      this.$axios.get(`/marketing/${this.company.slug}`)
        .then(resp => {
          this.$store.commit('marketing/setMarketingSettings', resp.data)
        })
        .catch(() => {})
    },
    sanitizeUnusedObject (strings, arrays) {
      if (strings && strings.length) {
        strings.forEach(f => {
          if (this.offer[f]) this.offer[f] = null
        })
      }
      if (arrays && arrays.length) {
        arrays.forEach(o => {
          if (this.offer[o]) this.offer[o] = []
        })
      }
    },
    saveData (tabs) {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      if (tabs === 3) {
        this.saveOfferData()
      } else if (tabs === 4) {
        this.$refs.whatsapp.saveData()
      } else if (tabs === 5) {
        this.$refs.sms.saveData()
      } else if (tabs === 6) {
        this.$refs.email.saveData()
      } else {
        this.tabs++
      }
    },
    saveOfferData () {
      this.isLoading = true
      let payload = JSON.parse(JSON.stringify(this.offer))
      payload.name = this.opportunity.name
      if (payload.discount_amount) {
        payload.discount_amount = Math.round(Number(payload.discount_amount) * this.$currency.multiplier)
      }
      if (this.startDate) {
        payload.start_at = `${this.startDate} ${this.startTime}`
      }
      if (this.setEndAt) {
        payload.end_at = `${this.endDate} ${this.endTime}`
      }
      payload.purchase_products = this.offer.purchase_products.map(m => m.id)
      payload.free_products = this.offer.free_products.map(m => m.id)
      payload.groups = this.offer.groups.map(m => { return { id: m.id, include_later_members: m.include_later_members } })
      if (!this.audienceGroups) {
        payload.groups = []
      }
      if (!this.filterCustomers) {
        payload.customers = []
      }
      if (this.offer.id) {
        for (const key in payload) {
          if (payload[key] === null) {
            delete payload[key];
          }
        }
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
          .then(resp => {
            let offer = resp.data
            if (offer.discount_amount) {
              offer.discount_amount = Number(offer.discount_amount) / this.$currency.multiplier
            }
            this.offer = offer
            this.tabs++
            this.fetchBlastData()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        payload.opportunity = this.opportunity.id
        this.$axios.post(`/marketing/${this.company.slug}/offers`, payload)
          .then(resp => {
            let offer = resp.data
            if (offer.discount_amount) {
              offer.discount_amount = Number(offer.discount_amount) / this.$currency.multiplier
            }
            this.offer = offer
            this.tabs++
            this.fetchBlastData()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    updateDeliverance () {
      this.fetchBlastData()
      if (this.tabs < 6) {
        this.tabs++
      } else {
        this.$emit('updated')
        this.closeDialog()
      }
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height: 2px;
  top: 48px;
  left: 0px;
  right: 0px;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>